import React from 'react'
import styled from 'styled-components'
import { Alert as AlertBs, AlertProps } from '@bootstrap-styled/v4'

// type definition
// export type AlertProps = {
//     className?: string
// } & React.ComponentPropsWithoutRef<typeof AlertBs>

const Alert = styled(AlertBs)<AlertProps>`
    &.alert {
        font-weight: ${props => props.theme['$font-weight-medium']};
        font-size: ${props => props.theme['$text-small']};
        text-align: center;

        span {
            font-weight: ${props => props.theme['$font-weight-bold']};
            padding: ${props => `0 ${props.theme['$spacers'][1]}`};
        }
    }
` as typeof AlertBs

export default Alert
